<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <template v-if="box">
      <box-form
        :isLoading="isLoading"
        :box="box"
        :onSubmit="onSubmit">
      </box-form>
    </template>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import BoxForm from './BoxForm.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { biobankRegistry } = services;
const { boxService } = biobankRegistry;

export default {
  name: 'BoxCreate',
  components: {
    BoxForm,
    LandingCreate,
  },
  data: () => ({
    isLoading: false,
    content: {
      pageTitle: 'Update Box',
      enableBackButton: true,
    },
    box: null,
  }),
  async created() {
    const { id } = this.$route.params;
    const box = await boxService.getOne({ id });
    console.log('box', box);
    this.box = box;
  },
  methods: {
    async onSubmit(dataChange) {
      const data = Object.assign(this.box || {}, dataChange);

      this.isLoading = true;
      try {
        await boxService.update({ box: data });

        this.$snackbar.showOk({ text: 'Successfully updated box!' });

        this.$router.push({ name: 'box.list' });
      } catch (e) {
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
      this.isLoading = false;
    },
  },
};
</script>
